import React, { FC } from "react";

import { Column, DesktopMenuList, MenuBanner, Row } from "../../../components";

const DMWomenFlyout: FC = () => {
  return (
    <Row>
      <Column>
        <Row>
          <Column xs={2}>
            <DesktopMenuList
              titleLink={{ text: "New & FEATURED" }}
              linksItems={[{ text: "New arrivals" }]}
            />
          </Column>

          <Column xs={2}>
            <DesktopMenuList
              titleLink={{ text: "Tops" }}
              linksItems={[
                { text: "Hoodies and Sweatshirts" },
                { text: "Shirts" },
                { text: "Tanks and Vests" },
                { text: "Jackets" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
            <DesktopMenuList
              titleLink={{ text: "Bottoms" }}
              linksItems={[
                { text: "Pants" },
                { text: "Shorts" },
                { text: "Leggins" },
                { text: "Skirts" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
          </Column>

          <Column xs={2}>
            <DesktopMenuList
              titleLink={{ text: "Shoes" }}
              linksItems={[
                { text: "Hiking and outdoor shoes" },
                { text: "Running Shoes" },
                { text: "Sneakers" },
                { text: "Sandals and slippers" },
                { text: "Indoor shoes" },
                { text: "Rain boots" },
                { text: "Basketball shoes" },
                { text: "Football shoes" },
                { text: "Biking shoes" },
                { text: "Tennis shoes" },
                { text: "Golf shoes" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
          </Column>

          <Column xs={2}>
            <DesktopMenuList
              titleLink={{ text: "Accessories" }}
              linksItems={[
                { text: "Face covers" },
                { text: "Bags" },
                { text: "Bagpacks" },
                { text: "Headwear" },
                { text: "Gloves" },
                { text: "Scarves and shawls" },
                { text: "Socks" },
                { text: "Sunglasses" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
          </Column>

          <Column xs={2}>
            <DesktopMenuList
              titleLink={{ text: "Swimwear" }}
              linksItems={[
                { text: "Swimsuits" },
                { text: "Wetsuits" },
                { text: "Water shorts" },
                { text: "Cover Ups" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
            <DesktopMenuList
              titleLink={{ text: "Underwear" }}
              linksItems={[
                { text: "Sport Bras" },
                { text: "Base Layers" },
                { text: "Briefs and Boxers" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
          </Column>

          <Column xs={2}>
            <DesktopMenuList
              titleLink={{ text: "Shop by sport" }}
              linksItems={[
                { text: "Running" },
                { text: "Fitness" },
                { text: "Cycling" },
                { text: "Winter Sports" },
                { text: "Outdoors" },
                { text: "Team Sports" },
                { text: "Water sports" },
                { text: "Martial Arts & Boxing" },
                { text: "Racket sports" },
                { text: "Games and Activities" },
                { text: "View all", classes: { root: "nav-menu__link--all" } },
              ]}
            />
          </Column>
        </Row>
      </Column>
      <Column xs={2}>
        <MenuBanner
          image={{ src: "assets/images/placeholder-1.png", alt: "placeholder" }}
          title="REIMAGINED BOOTS FOR STRIKERS"
          description="Play your fastest game from start to finish."
          link={{ href: "/" }}
        />
        <MenuBanner
          image={{ src: "assets/images/placeholder-1.png", alt: "placeholder" }}
          title="50% OFF ALL NIKE GEAR"
          description="Get the latest nike gear for a great discount."
          link={{ href: "/" }}
        />
      </Column>
    </Row>
  );
};

export default DMWomenFlyout;
